// components/HomeBanner1.jsx
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner2.jpg";
import banner4 from "../assets/banner4.jpg";
import banner6 from "../assets/banner3.jpg"; // Note: Imported as banner6 but source is banner3.jpg
import { FaArrowRightLong } from "react-icons/fa6";
import { IoMdArrowDropright } from "react-icons/io";

export default function HomeBanner1() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);

  // Consistent banner set used across service pages for visual uniformity
  const slides = [banner6, banner2, banner1, banner4];

  useEffect(() => {
    setReady(true);
  }, []);

  useEffect(() => {
    if (!ready) return;
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // 5s rotation matching service pages
    return () => clearInterval(interval);
  }, [ready, slides.length]);

  if (!ready) {
    return (
      <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <section 
      className="MainBodySection hero-section position-relative"
      aria-label="Home Hero Section"
    >
      {/* ================= ROTATING BACKGROUNDS ================= */}
      {slides.map((banner, i) => (
        <div
          key={i}
          style={{
            backgroundImage: `url(${banner})`,
            backgroundAttachment: "scroll",
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            transition: "opacity 2s ease-in-out",
            opacity: i === activeSlide ? 0.4 : 0, // Slightly darker overlay for text readability
            zIndex: 0
          }}
          aria-hidden={i !== activeSlide}
        />
      ))}

      {/* ================= DARK OVERLAY (Uniformity with Service Pages) ================= */}
      <div className="hero-overlay" />

      {/* ================= CONTENT ================= */}
      <div className="hero-content">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-10 text-center">
              
              <h1 className="font-bold text-primary mb-5">ATRIC Business Consulting Limited</h1>

              {/* Headline - Responsive Clamp */}
              <h1 
                className="hero-title"
              >
                Business Consulting Excellence
              </h1>

              {/* Subheadline */}
              <p 
                className="hero-subtitle mx-auto"
              >
                Accounting, Tax, Audit & Financial Management in Tanzania
              </p>

              {/* CTA Buttons - Matching ServicesBanner1 Style */}
              <div className="d-flex flex-wrap justify-content-center gap-3 my-5">
                <button
                  className="btn btn-primary btn-rounded px-5 py-3 rounded-pill d-flex align-items-center gap-2"
                  onClick={() => appContext.navTo({ item: "services" })}
                >
                  Explore Services
                  <FaArrowRightLong size={20} />
                </button>

                <button
                  className="btn hero-cta hero-cta--ghost btn-lg px-5 py-3 rounded-pill mDesktopOnly"
                  onClick={() => appContext.navTo({ item: "contact_us" })}
                >
                  Contact Us
                </button>
              </div>
             
            </div>
          </div>
        </div>
      </div>

      {/* ================= CSS ANIMATIONS ================= */}
      <style>{`
        .hero-section {
          min-height: 100vh;
          display: flex;
          align-items: center;
          background: linear-gradient(135deg, rgba(15, 23, 42, 0.5) 0%, rgba(30, 41, 59, 0.5) 100%);
          overflow: hidden;
        }
        .hero-overlay {
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.8) 55%, rgba(0,0,0,0.75) 100%);
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
        }
        .hero-content {
          position: relative;
          z-index: 2;
          padding: 2rem 1rem;
          width: 100%;
        }
        .hero-eyebrow {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 0.4rem 1rem;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.05);
          color: #e2e8f0;
          font-size: 0.85rem;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          margin-bottom: 1.25rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
        .hero-title {
          color: #f8fafc;
          font-weight: 800;
          font-size: clamp(2.25rem, 5vw, 3.6rem);
          line-height: 1.12;
          letter-spacing: -0.6px;
          text-shadow: 0 6px 18px rgba(0,0,0,0.4);
          margin-bottom: 0.75rem;
        }
        .hero-subtitle {
          color: #e2e8f0;
          max-width: 700px;
          font-size: clamp(1rem, 2vw, 1.2rem);
          line-height: 1.7;
          opacity: 0.92;
          text-shadow: 0 3px 8px rgba(0,0,0,0.35);
        }
        .hero-cta {
          font-weight: 600;
          border: none;
          transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
        }
        .hero-cta--primary {
          background: linear-gradient(135deg, #0f766e, #14b8a6);
          color: #fff;
          box-shadow: 0 8px 20px rgba(20, 184, 166, 0.35);
        }
        .hero-cta--primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 26px rgba(20, 184, 166, 0.45);
        }
        .hero-cta--ghost {
          background: rgba(255,255,255,0.08);
          border: 1px solid rgba(255,255,255,0.3);
          color: #f8fafc;
          backdrop-filter: blur(4px);
        }
        .hero-cta--ghost:hover {
          background: rgba(255,255,255,0.16);
          border-color: rgba(255,255,255,0.5);
        }
        .hero-dot {
          width: 12px;
          height: 12px;
          border-radius: 999px;
          border: none;
          background: rgba(255,255,255,0.35);
          transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: pointer;
        }
        .hero-dot.is-active {
          width: 32px;
          background: #14b8a6;
        }
        .hero-scroll {
          position: absolute;
          bottom: 1.5rem;
          left: 50%;
          transform: translateX(-50%);
          z-index: 2;
          animation: bounce 2s infinite;
        }
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% {transform: translateY(0) rotate(90deg);}
          40% {transform: translateY(-10px) rotate(90deg);}
          60% {transform: translateY(-5px) rotate(90deg);}
        }
        @media (prefers-reduced-motion: reduce) {
          * { transition: none !important; animation: none !important; }
        }
      `}</style>
    </section>
  );
}
